// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=range][data-v-56512b99]::-webkit-slider-thumb {\n  z-index: 2;\n  position: relative;\n  height: 18px;\n  width: 18px;\n  border-radius: 100%;\n  background: #135aba;\n  cursor: pointer;\n  -webkit-appearance: none;\n}", ""]);
// Exports
module.exports = exports;
